
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/history.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-history-demo-plugin-history"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/history.zh.md?type=demo')
};